import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Paper,
  Divider,
  CircularProgress,
} from '@mui/material';import api from '../../services/api';
import Logo from '../../assets/images/Nudrha-Logo2.png';
import { useTranslation } from 'react-i18next';
import { formatDateDisplay } from '../../utils/dateUtils';

const HorseNFCPage = () => {
  const { id } = useParams();
  const [horse, setHorse] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  useEffect(() => {
    const fetchHorse = async () => {
      try {
        const response = await api.get(
          `${process.env.REACT_APP_API_URL}/horses/${id}`
        );
        setHorse(response.data);
      } catch (error) {
        console.error('Error fetching horse data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchHorse();
  }, [id]);

  if (loading)
    return (
      <Box textAlign="center" mt={5}>
        <CircularProgress />
      </Box>
    );
  if (!horse)
    return (
      <Box textAlign="center" mt={5}>
        {t('Horse not found')}
      </Box>
    );

  return (
    <Box
      sx={{ maxWidth: 600, mx: 'auto', mt: 5, px: 2 }}
      dir={isArabic ? 'rtl' : 'ltr'}
    >
      {/* Logo */}
      <Box textAlign="center" mb={3}>
        <img
          src={Logo}
          alt="Logo"
          style={{ width: '85px', marginBottom: '20px' }}
        />{' '}
      </Box>

      {/* Horse Info */}
      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" gutterBottom textAlign="center">
          {horse.name} | {horse.name_arabic}
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography>
          <strong>{t('RFID Chip')}:</strong> {horse.rfid_chip_number}
        </Typography>
        <Typography>
          <strong>{t('Date of Birth')}:</strong>{' '}
          <span className="date-ltr">{formatDateDisplay(horse.date_of_birth)}</span>
        </Typography>
        <Typography>
          <strong>{t('Father')}:</strong> {horse.father_name}
        </Typography>
        <Typography>
          <strong>{t('Mother')}:</strong> {horse.mother_name}
        </Typography>
        <Typography>
          <strong>{t('Gender')}:</strong> {horse.gender}
        </Typography>
      </Paper>

      {/* Service Buttons */}
      <Box display="flex" flexDirection="column" gap={2}>
        <Button variant="contained" fullWidth href={`/AddFarrierRecord`}>
          {t('Add Farrier Record')}
        </Button>
        <Button variant="contained" fullWidth href={`/VetClinicForm`}>
          {t('Add Clinic Record')}
        </Button>
        <Button variant="contained" fullWidth href={`/HorseTransportForm`}>
          {t('Add Transport')}
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          fullWidth
          href={`/horse-details-client/${horse.horse_id}`}
        >
          {t('View Full Horse Info')}
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          fullWidth
          href={`/HorseHistory/${horse.horse_id}`}
        >
          {t('Horse History')}
        </Button>
      </Box>
    </Box>
  );
};

export default HorseNFCPage;
